// Smart API base URL: uses same-origin on deployed custom domains, falls back to REACT_APP_BACKEND_URL for preview/dev
const getApiBase = () => {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && !window.location.hostname.includes('preview.emergentagent.com')) {
    return `${window.location.origin}/api`;
  }
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const API = getApiBase();
export const API_HOST = typeof window !== 'undefined' && window.location.hostname !== 'localhost' && !window.location.hostname.includes('preview.emergentagent.com')
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL;
